import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IPollingServiceStopper, 'IPollingServiceStopper');
initMetadataForClass(PollingServiceRegistry, 'PollingServiceRegistry', PollingServiceRegistry, VOID, [IPollingServiceStopper]);
//endregion
function IPollingServiceStopper() {
}
function PollingServiceRegistry() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.h6w_1 = ArrayList_init_$Create$();
}
function get_pollingModule() {
  _init_properties_PollingModule_kt__wuf2fx();
  return pollingModule;
}
var pollingModule;
function pollingModule$lambda($this$module) {
  _init_properties_PollingModule_kt__wuf2fx();
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = pollingModule$lambda$lambda;
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Singleton_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(PollingServiceRegistry), null, definition, kind, secondaryTypes);
  var factory = new SingleInstanceFactory(def);
  $this$module.p1c(factory);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory);
  }
  var tmp = new KoinDefinition($this$module, factory);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [getKClass(IPollingServiceStopper)];
  binds(tmp, tmp$ret$5);
  return Unit_instance;
}
function pollingModule$lambda$lambda($this$single, it) {
  _init_properties_PollingModule_kt__wuf2fx();
  return new PollingServiceRegistry();
}
var properties_initialized_PollingModule_kt_f7uen3;
function _init_properties_PollingModule_kt__wuf2fx() {
  if (!properties_initialized_PollingModule_kt_f7uen3) {
    properties_initialized_PollingModule_kt_f7uen3 = true;
    pollingModule = module_0(VOID, pollingModule$lambda);
  }
}
//region block: exports
export {
  get_pollingModule as get_pollingModule1lzsu7o6x7b4d,
  IPollingServiceStopper as IPollingServiceStopper2dkq3n37epmm9,
  PollingServiceRegistry as PollingServiceRegistry1wltrmn5ft1vf,
};
//endregion

